// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EventsService } from '@services/events.service';
import { UserService } from '@services/user.service';
import { SystemMessageModalComponent } from 'src/app/modals/system-message-modal/system-message-modal.component';

@Component({
    selector: 'system-message-banner',
    templateUrl: './system-message-banner.component.html',
    styleUrls: ['./system-message-banner.component.scss'],
})
export class SystemMessageBannerComponent implements OnInit, OnDestroy {
    private isComponentAlive = true;
    public message: any;

    constructor(
        private readonly dialog: MatDialog,
        private readonly userService: UserService,
        private readonly eventsService: EventsService
    ) {}

    ngOnInit(): void {
        this.eventsService.build().then(() =>
            this.eventsService.onSystemMessages((messages) => {
                this.message = messages;
            })
        );
    }

    public showMessage(): void {
        this.dialog.open(SystemMessageModalComponent, {
            data: {
                systemMessageData: this.message[0],
            },
        });
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
